import { userConstants } from "../../constant";

const initialState = {
  list: [],
  detail: null,
};

export function jobPostings(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_JOB_POSTINGS:
      return { ...state, list: action.jobPostings || [] };
    case userConstants.GET_JOB_POSTING_DETAIL:
      return { ...state, detail: action.jobPostingDetail || null };
    default:
      return state;
  }
}
